import { useEffect, useState } from "react";
import { getFromStorage, saveOnConfigFile } from "../../utils/helpers";
import { LocalStorageKeys, mergeStyle } from "../../utils/constant";
import { useAppSelector } from "../../redux/stateHooks";
import {
  getObjectDetailsToSaveAsConfig,
  getSelectedTableName,
} from "../../redux/reducers/objectSlice";

function SavePopup({ onCancel }) {
  const object = useAppSelector(getObjectDetailsToSaveAsConfig);
  const selectedTableName = useAppSelector(getSelectedTableName);
  const [tableName, setTableName] = useState(selectedTableName);
  useEffect(() => {
    setTableName(selectedTableName);
  }, [selectedTableName]);
  const handleSaveTable = async () => {
    if (tableName.length < 3) return;
    const config = getFromStorage(LocalStorageKeys.CONFIG) || {};
    const newEntry = { ...object, tableName };
    // if mergestyle not defined then set to default as DATA_MERGE
    if (!config?.mergeStyle) {
      config.mergeStyle = mergeStyle.DATA_MERGE;
    }
    if (!config?.tables) {
      const newValue = {
        ...config,
        tables: [{ ...newEntry, createdAt: new Date().toISOString() }],
      };
      await saveOnConfigFile(LocalStorageKeys.CONFIG, newValue);
    } else {
      // Check if the tableName already exists in the config
      const existingIndex = config?.tables.findIndex(
        (item) => item.tableName === newEntry.tableName
      );

      if (existingIndex !== -1) {
        // If tableName exists, update the existing object
        config.tables[existingIndex] = {
          ...newEntry,
          updatedAt: new Date().toISOString(),
        };
      } else {
        // If tableName does not exist, add the new entry
        config.tables.push({
          ...newEntry,
          createdAt: new Date().toISOString(),
        });
      }

      // Save the updated config back to storage
      await saveOnConfigFile(LocalStorageKeys.CONFIG, config);
    }
    onCancel();
  };

  return (
    <div className="ng-star-inserted">
      <div className="preset-modal">
        <div className="modal-head">
          <a className="closed-btn cursor-pointer" onClick={onCancel}></a>
          <p>Save Template</p>
        </div>
        <div className="modal-cnt">
          <div className="form-group">
            <input
              value={tableName}
              className="form-control ng-untouched ng-pristine ng-valid"
              placeholder="Enter template name"
              type="text"
              onChange={(e) => {
                setTableName(e.target.value);
              }}
            />
          </div>
          <div className="modal-bottom clearfix">
            <button
              className="btn btn-primary float-left"
              type="button"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary float-right active"
              type="button"
              onClick={handleSaveTable}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SavePopup;
